<script setup lang="ts">
import GroupsLayout from '../features/groups/GroupsLayout.vue';
</script>

<template>
  <GroupsLayout />
</template>
